import { render, staticRenderFns } from "./AddVkUser.vue?vue&type=template&id=57570503&scoped=true"
import script from "./AddVkUser.vue?vue&type=script&lang=js"
export * from "./AddVkUser.vue?vue&type=script&lang=js"
import style0 from "./AddVkUser.vue?vue&type=style&index=0&id=57570503&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57570503",
  null
  
)

export default component.exports